import type { CasesGamePhases, ICaseRevisionItem, ICaseSpinItem } from '@dev-fast/types';

import type { ICurrentLevelQuestLevel, IEventLevel, ILastItem, IPossibleItem, ITopGamer } from '../types/frontend';

export interface AprilMadnessEventModel {
  initialized: boolean;
  isEventStateLoading: boolean;
  endAt: string;
  currentStep: number;
  currentExp: number;
  currentLevelProgressPercent: number;
  nextLevelRequiredExp: number;
  currentLevelQuestLevel: ICurrentLevelQuestLevel | null;
  collected: number;
  userTakenItems: ILastItem[];
  eventLevels: IEventLevel[];
  possibleItems: IPossibleItem[];
  topOfGamers?: ITopGamer[];
  spinState?: CasesGamePhases;
  prizeSpinTracks: ICaseSpinItem[][];
  caseItems: Record<number, ICaseRevisionItem>;
}

export const DEFAULT_APRIL_MADNESS_EVENT_STATE: AprilMadnessEventModel = {
  initialized: false,
  isEventStateLoading: true,
  endAt: '',
  currentStep: 0,
  currentExp: 0,
  currentLevelProgressPercent: 0,
  nextLevelRequiredExp: 0,
  currentLevelQuestLevel: null,
  collected: 0,
  userTakenItems: [],
  eventLevels: [],
  possibleItems: [],
  topOfGamers: [],
  prizeSpinTracks: [],
  caseItems: {},
};
